import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from './auth';

// mfaEnrollGuard：已登录但未绑定任何强因子（TOTP/Passkey）时，强制跳转 /security 完成绑定。
// 仅保护业务页（dashboard/apikeys 等）；/security 本身不挂此守卫，以便用户去绑定。
export const mfaEnrollGuard: CanActivateFn = async () => {
  // SSR：服务端无 localStorage，放行交给客户端 hydrate 后再判（避免刷新误重定向）。
  if (isPlatformServer(inject(PLATFORM_ID))) {
    return true;
  }
  const auth = inject(Auth);
  const router = inject(Router);
  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }
  if (auth.mfaEnrolled()) {
    return true;
  }
  // 本地标记为「未绑定」时，先向服务端复核真实 MFA 状态再决定——避免因本地 mfa_enrolled 陈旧
  // （如管理侧改动过 MFA 因子）把已绑定用户误跳到 /security。
  try {
    const s = await auth.getSecurityStatus();
    auth.applyMfaEnrolled(s.mfa_enrolled);
    if (s.mfa_enrolled) {
      return true;
    }
  } catch {
    /* 复核失败：保守按未绑定处理，跳绑定页 */
  }
  router.navigate(['/security']);
  return false;
};
